import { Row, Col, Card, Button, Container } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";

export default function Admin() {
  //   const { user } = useContext(UserContext);
  const navigate = useNavigate();

  return (
    <Container className="mt-4">
      <Row className="mb-4">
        <Col>
          <h1 className="text-center">Admin Dashboard</h1>
          <p className="text-center text-muted">Manage your e-commerce products</p>
        </Col>
      </Row>

      {/* Comprehensive Product Management */}
      <Row className="mb-4">
        <Col>
          <Card>
            <Card.Header>
              <h4>📊 Comprehensive Product Management</h4>
            </Card.Header>
            <Card.Body>
              <p>Complete dashboard with all product operations in one place</p>
              <Link to={"/admin-product-management"}>
                <Button variant="primary" size="lg" className="w-100">
                  🚀 Product Management Dashboard
                </Button>
              </Link>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {/* Individual Operations */}
      <Row>
        <Col md={6} className="mb-3">
          <Card>
            <Card.Header>
              <h5>➕ Create Operations</h5>
            </Card.Header>
            <Card.Body>
              <Link to={"/createProduct"} className="d-block mb-2">
                <Button variant="success" className="w-100">
                  Create New Product
                </Button>
              </Link>
            </Card.Body>
          </Card>
        </Col>

        <Col md={6} className="mb-3">
          <Card>
            <Card.Header>
              <h5>📋 View Operations</h5>
            </Card.Header>
            <Card.Body>
              <Link to={"/all"} className="d-block mb-2">
                <Button variant="info" className="w-100">
                  View All Products
                </Button>
              </Link>
            </Card.Body>
          </Card>
        </Col>

        <Col md={6} className="mb-3">
          <Card>
            <Card.Header>
              <h5>✏️ Update Operations</h5>
            </Card.Header>
            <Card.Body>
              <p className="small text-muted">Note: You'll need a product ID in the URL</p>
              <Button
                variant="warning"
                className="w-100"
                onClick={() => {
                  const productId = prompt("Enter Product ID to update:");
                  if (productId) {
                    navigate(`/updateProduct/${productId}`);
                  }
                }}
              >
                Update Product
              </Button>
            </Card.Body>
          </Card>
        </Col>

        <Col md={6} className="mb-3">
          <Card>
            <Card.Header>
              <h5>🔄 Status Operations</h5>
            </Card.Header>
            <Card.Body>
              <Link to={"/deactivate"} className="d-block mb-2">
                <Button variant="warning" className="w-100">
                  Deactivate Products
                </Button>
              </Link>
              <Link to={"/activate"} className="d-block mb-2">
                <Button variant="success" className="w-100">
                  Activate Products
                </Button>
              </Link>
            </Card.Body>
          </Card>
        </Col>

        <Col md={12} className="mb-3">
          <Card border="danger">
            <Card.Header className="bg-danger text-white">
              <h5>⚠️ Danger Zone</h5>
            </Card.Header>
            <Card.Body>
              <p className="text-danger">
                <strong>Warning:</strong> Permanent deletion cannot be undone!
              </p>
              <Link to={"/delete-product"}>
                <Button variant="danger" className="w-100">
                  🗑️ Delete Products Permanently
                </Button>
              </Link>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}
